import {
  emailField,
  PHONE_NUMBER_REGEX,
  phoneNumberField,
} from "toptaal-shared"
import { z } from "zod"

export const onboardingStudentContactInfoSchema = z.object({
  email: emailField,
  secondaryEmail: emailField.nullable().optional(),
  phoneNumberCall: phoneNumberField,
  phoneNumberWhatsapp: z
    .string()
    .regex(PHONE_NUMBER_REGEX)
    .or(z.literal(""))
    .nullable(),
  samePhone: z.boolean().optional().default(true),
})

export type OnboardingStudentContactInfoInput = z.input<
  typeof onboardingStudentContactInfoSchema
>

export type OnboardingStudentContactInfoOutput = z.infer<
  typeof onboardingStudentContactInfoSchema
>
